var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoltBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5001 21H10.5001L11.5001 14H8.00011C7.42011 14 7.43011 13.68 7.62011 13.34C7.81011 13 7.67011 13.26 7.69011 13.22C8.98011 10.94 10.9201 7.54 13.5001 3H14.5001L13.5001 10H17.0001C17.4901 10 17.5601 10.33 17.4701 10.51L17.4001 10.66C13.4601 17.55 11.5001 21 11.5001 21Z",
    fill: "#223CDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltBlue);
export default __webpack_public_path__ + "static/media/bolt_blue.d91dace03603dc474ae4196ecddd09d2.svg";
export { ForwardRef as ReactComponent };